import { render, staticRenderFns } from "./taggatewayscoveragemodal.vue?vue&type=template&id=6bba8fc8"
import script from "./taggatewayscoveragemodal.vue?vue&type=script&lang=js"
export * from "./taggatewayscoveragemodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports